export const detectDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();

    if (/android/.test(userAgent)) {
        return 'android';
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
        return 'ios';
    } else if (/mac/.test(platform)) {
        return 'mac';
    } else if (/win/.test(platform)) {
        return 'windows';
    } else {
        return 'unknown';
    }
};